import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-chevron-bottom",
  "use": "foquz-icon-chevron-bottom-usage",
  "viewBox": "0 0 14 9",
  "content": "<symbol viewBox=\"0 0 14 9\" fill=\"none\" id=\"foquz-icon-chevron-bottom\"><path d=\"M1 1.969l6 6 6-6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol